<template>
	<AppContentLayout class="dropdowns-list">
		<div class="lists-container scroller">
			<AppLoader class="mt-3" color="#101840" size="18px" v-if="showLoader" />
			<Col v-else class="pr-7">
				<ButtonsDropdownList v-on="$listeners" :isLoading="isLoading || showLoader" :buttonDropdowns="filteredButtonDropdowns" />
			</Col>
			<div v-intersect="endIntersect" v-if="hasNextPage" class="load-more-empty-space width-100 display-flex flex-centerize">
				<div class="width-100">
					<Loader small v-if="isLoading && currentPage > 1 && !showLoader" />
				</div>
			</div>
		</div>
	</AppContentLayout>
</template>
<script>
import AppContentLayout from '@/views/AppLayout/AppContentLayout.vue';
import { useButtonDropdown } from '@/store/modules/buttonDropdowns/getters';
import { getButtonDropdowns } from '@/store/modules/buttonDropdowns/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import ButtonsDropdownList from '@/views/ButtonsDropdownView/ButtonsDropdownList.vue';
export default {
	name: 'ButtonsDropdownView',
	components: { AppContentLayout, ButtonsDropdownList },
	props: {
		page: { type: Number, default: 1 },
		filterBy: { type: Object, default: () => ({}) },
		idsToShow: { type: Array }, // this is a semi-local filter, passed prom credentials edit module route, -- different from 'filterBy', which makes a network request
	},
	computed: {
		...mapGettersShorthand({ useButtonDropdown }),
		filteredButtonDropdowns() {
			return this.idsToShow?.length > 0
				? this.currentButtonDropdownsFromStore.filter((x) => this.idsToShow.includes(`${x.id}`))
				: this.currentButtonDropdownsFromStore;
		},
		currentButtonDropdownsFromStore() {
			const allLocalIds = this.currentButtonDropdowns.map(({ id }) => id);
			return allLocalIds.map((btnDropdownId) => this.useButtonDropdown(btnDropdownId)).filter((btnDropdown) => btnDropdown);
		},
		showLoader() {
			return !this.afterOneSecond || (this.isLoading && this.currentPage === 1);
		},
	},
	methods: {
		...mapActionsShorthand({ getButtonDropdowns }),
		onMounted() {
			setTimeout(() => {
				this.afterOneSecond = true;
			}, 1500);
			this.fetchButtonDropdowns(this.currentPage);
		},
		onScrollToBottom() {
			this.currentPage++;
			this.fetchButtonDropdowns(this.currentPage);
		},
		clearState() {
			this.currentButtonDropdowns = [];
			this.currentPage = this.page;
			this.afterOneSecond = false;
		},
		async fetchButtonDropdowns(page) {
			this.isLoading = true;
			const buttonDropdownsData = await this.getButtonDropdowns({ page, filterBy: this.filterBy });
			this.isLoading = false;
			this.hasNextPage = Boolean(buttonDropdownsData.next);
			this.currentButtonDropdowns = [...this.currentButtonDropdowns, ...buttonDropdownsData.results];
		},
		endIntersect(entries, observer, isIntersecting) {
			if (isIntersecting) {
				this.onScrollToBottom();
			}
		},
	},

	mounted() {
		this.onMounted();
	},
	data() {
		return {
			isLoading: false,
			hasNextPage: false,
			afterOneSecond: false,
			currentPage: this.page,
			currentButtonDropdowns: [],
		};
	},
};
</script>

<style scoped lang="scss">
.dropdowns-list {
	.lists-container {
		overflow-y: auto;
		padding-bottom: 10px;
	}
}
.load-more-empty-space {
	height: 100px;
}

.scroller {
	overflow: auto;
	color: #c1c1c1;
}
</style>
